import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-[#F8F8F8] flex items-center justify-center">
      <div className="w-6 h-6 border-2 border-[#6B2D3E] border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/escritorio" replace />;
  return children;
}
